import { useEffect, useMemo, useState } from "react";
import { Subject, debounceTime } from "rxjs";

const defaultDebounceTime = 500;

const Debounce = <T extends string | null | number | object | undefined>(
    value: T,
    time: number = defaultDebounceTime,
): T | null => {
    const [debounced, setDebounced] = useState<T | null>(null);
    const onSearch$ = useMemo(() => new Subject<T>(), []);

    useEffect(() => {
        const subscribe = onSearch$.pipe(debounceTime(time)).subscribe({
            next: (debounced) => {
                setDebounced(debounced);
            },
        });

        return () => {
            if (subscribe) {
                subscribe.unsubscribe();
            }
        };
    }, [time]);

    useEffect(() => {
        onSearch$.next(value);
    }, [value]);

    return debounced;
};

export default Debounce;
